export default "__VITE_ASSET__CWDwdlU2__"